import React from 'react';
import EditorIndent from '@wix/da-ds/pkg/Icons/24x24/EditorIndent';
import { isExtensionInstalled } from '../../utils/tiptap';
import { useTranslation } from 'react-i18next';
import EditorIconButton from '../_partials/EditorIconButton';
const Indent = ({ editor, hideWhenNotEnabled = true })=>{
    const { t } = useTranslation('editor');
    if (!editor.isEditable || hideWhenNotEnabled && !isExtensionInstalled(editor, 'indent')) {
        return null;
    }
    if (editor.isActive('listItem')) {
        return /*#__PURE__*/ React.createElement(EditorIconButton, {
            featureId: "format:indent",
            icon: EditorIndent,
            onClick: ()=>editor.chain().focus().sinkListItem('listItem').run(),
            disabled: !editor.can().sinkListItem('listItem'),
            tooltipText: t('button.indent'),
            "aria-label": t('button.indent')
        });
    }
    return /*#__PURE__*/ React.createElement(EditorIconButton, {
        featureId: "format:indent",
        icon: EditorIndent,
        onClick: ()=>editor.chain().focus().indent('block').run(),
        disabled: !editor.can().chain().focus().indent('block').run(),
        tooltipText: t('button.indent'),
        "aria-label": t('button.indent')
    });
};
Indent.displayName = 'Indent';
export default Indent;

//# sourceMappingURL=Indent.js.map